<script setup lang="ts">
import type { FullStars } from '@libs/trip-planner-interfaces';

import AppSvgIcon from '../appSvgIcon/AppSvgIcon.vue';
import type { AppSvgIconSize } from '../appSvgIcon/AppSvgIcon.model';

export interface AppStarsProps {
  amount: FullStars;
  size: AppSvgIconSize;
}

const props = defineProps<AppStarsProps>();
</script>

<template>
  <div class="app-stars">
    <AppSvgIcon
      v-for="star in Math.floor(props.amount)"
      :key="star"
      :size="props.size"
      name="star"
      color="color-brand-violet"
      :translate="{ x: 2, y: 2 }"
    />
    <AppSvgIcon
      v-if="props.amount % 1 !== 0"
      name="halfStar"
      :size="props.size"
      color="color-brand-violet"
      :translate="{ x: 2, y: 2 }"
    />
  </div>
</template>

<style scoped lang="scss">
.app-stars {
  display: flex;
  align-items: center;
}
</style>
